import { __require as _ } from "./_baseForOwn.js";
import { __require as u } from "./_createBaseEach.js";
var r, e;
function t() {
  if (e) return r;
  e = 1;
  var a = _(), s = u(), i = s(a);
  return r = i, r;
}
export {
  t as __require
};
